function toggleCart() {
  const drawer = document.querySelector("#cart-drawer");
  if (!drawer.classList.contains("is-drawer-open")) {
    drawer.classList.add("is-drawer-open");
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
    document
      .querySelectorAll(['[data-animation="cart-items-fade"]'])
      .forEach((item) => {
        item.classList.add("is-animated");
      }, 50);
  } else {
    drawer.classList.add("is-closing");
    document.body.style.overflow = "";
    document
      .querySelectorAll(['[data-animation="cart-items-fade"]'])
      .forEach((item) => {
        item.classList.remove("is-animated");
      }, 50);
    setTimeout(() => {
      drawer.classList.remove("is-drawer-open");
      drawer.classList.remove("is-closing");
      drawer.classList.remove("is-open");
    }, 300);
  }
}

let upgradeFromVariantId = "";
let upgradeBlock = null;

function bodyOverflow() {
  setTimeout(() => {
    document.body.style.overflow = "hidden";
  }, 500);
  window.removeEventListener("transitionend", bodyOverflow);
}

let isOneClickUpSell = false;

function fetchCart() {
  fetch("/cart?section_id=api-cart-drawer")
    .then((response) => response.text())
    .then((response) => {
      document.querySelector("#cart-drawer").classList.remove("is-loading");

      document
        .querySelector("#cart-drawer")
        .querySelector(".drawer__inner").innerHTML = new DOMParser()
        .parseFromString(response, "text/html")
        .querySelector(".drawer__inner").innerHTML;

      if (
        !document
          .querySelector("#cart-drawer")
          .classList.contains("is-drawer-open")
      ) {
        setTimeout(() => {
          toggleCart();
        }, 0);
      }

      document.querySelectorAll(".free-gift-loading").forEach((item) => {
        item.classList.remove("free-gift-loading");
      });
    });

  fetch("/cart.js")
    .then((response) => response.json())
    .then((response) => {
      isOneClickUpSell = false;
      document.querySelectorAll("cart-counter").forEach((item) => {
        let count = response.item_count;
        const protectionId = Number(
          item.getAttribute("data-order-protection-id"),
        );

        for (const item of response.items) {
          if (item.product_id === protectionId) {
            count--;
          }
        }
        item.updateCount(count);
      });
    });
}

document.addEventListener("DOMContentLoaded", () => {
  let adding = false;
  // document
  //   .querySelectorAll(["#addToCart", "[data-add-to-cart"])
  //   .forEach((item) => {
  //     item?.addEventListener("click", (event) => {
  //       if (adding || event.target.getAttribute("disabled")) {
  //         return;
  //       }

  //       isOneClickUpSell = !!document.querySelector(
  //         ".ocu-hero-content__container",
  //       );

  //       event.target.classList.add("free-gift-loading");
  //       event.preventDefault();
  //       event.stopPropagation();

  //       const formData = new FormData(event.target.closest("form"));

  //       adding = true;

  //       fetch("/cart/add", {
  //         method: "POST",
  //         headers: {
  //           "X-Requested-With": "XMLHttpRequest",
  //           Accept: "application/javascript",
  //         },
  //         body: formData,
  //       })
  //         .then((response) => response.json())
  //         .then((response) => {
  //           if (response.status === 422) {
  //             document
  //               .querySelector("checkout-btn")
  //               ?.classList.remove("free-gift-loading");
  //             document
  //               .querySelector("#addToCart")
  //               ?.classList.remove("free-gift-loading");
  //             document
  //               .querySelectorAll("[data-add-to-cart]")
  //               .forEach((item) => {
  //                 item.classList.remove("free-gift-loading");
  //               });
  //           } else {
  //             setTimeout(
  //               () => {
  //                 fetchCart();
  //               },
  //               isOneClickUpSell ? 2000 : 0,
  //             );
  //             // fetchCart();
  //           }
  //           adding = false;
  //         });
  //     });
  //   });

  document.querySelectorAll("[data-account-toggle]").forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      window.location.href = item.dataset.accountUrl || "/account/login";
    });
  });

  document
    .querySelectorAll([
      "[data-cart-toggle]",
      "#cart-drawer .drawer__underlay",
      ".continue-shopping",
    ])
    .forEach((item) =>
      item.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        toggleCart();
      }),
    );

  if (!customElements.get("order-protection")) {
    customElements.define(
      "order-protection",
      class OrderProtection extends HTMLElement {
        constructor() {
          super();

          const btn = this.querySelector("a");
          const cartJson = JSON.parse(
            this.querySelector("#cart-json").innerHTML,
          );

          let index;
          for (const item of cartJson.items) {
            if (item.product_id === Number(this.getAttribute("data-id"))) {
              if (this.getAttribute("data-enabled") === "true") {
                btn.classList.add("active");
              } else {
                CartJS.removeItemById(btn.getAttribute("data-id"));
              }
            }
            index += 1;
          }

          btn.addEventListener("click", () => {
            if (window.noCartRefresh) {
              return;
            }

            btn.classList.toggle("active");
            document
              .querySelector("checkout-btn")
              ?.classList.add("free-gift-loading");
            window.noCartRefresh = true;
            if (this.querySelector("a").classList.contains("active")) {
              CartJS.addItem(btn.getAttribute("data-id"));
            } else {
              CartJS.removeItemById(btn.getAttribute("data-id"));
            }
          });
        }
      },
    );
  }
});

if (!customElements.get("upsell-block")) {
  customElements.define(
    "upsell-block",
    class UpsellBlock extends HTMLElement {
      constructor() {
        super();

        this.querySelector(".up-wrap-out .closeit")?.addEventListener(
          "click",
          (event) => {
            document
              .querySelector(".activeupsell")
              .classList.remove("activeupsell");
            document.body.style.overflow = "";
          },
        );

        this.querySelectorAll([
          ".up-wrap-out .open-cart",
          ".up-wrap-out .closeit",
        ]).forEach((item) =>
          item.addEventListener("click", (event) => {
            document
              .querySelector(".activeupsell")
              ?.classList.remove("activeupsell");
            document.body.style.overflow = "";
            fetchCart();
          }),
        );

        this.querySelector(".up-wrap-out .btns.cart")?.addEventListener(
          "click",
          (event) => {
            CartJS.removeItemById(upgradeFromVariantId);
            CartJS.addItem(
              event.target.closest(".cart-btn").getAttribute("data-upsell-id"),
              1,
            );
          },
        );
      }
    },
  );
}

if (!customElements.get("cart-item")) {
  customElements.define(
    "cart-item",
    class CartItem extends HTMLElement {
      constructor() {
        super();

        const freeGiftProduct = JSON.parse(
          document.querySelector("#free-products")?.innerHTML ?? "[]",
        );

        const productId = this.getAttribute("data-product-id");

        if (!freeGiftProduct.find((item) => item.id === Number(productId))) {
          this.querySelector(".cart_item_remove").style.display = "block";
          this.querySelector(".cart__quantity").style.display = "flex";
        }

        if (!freeGiftProduct.length) {
          document.querySelector("cart-drawer").classList.remove("is-loading");
        }

        this.querySelector(".cart_item_remove").addEventListener(
          "click",
          (event) => {
            document.querySelector("cart-drawer").classList.add("is-loading");

            CartJS.removeItem(event.target.getAttribute("data-line"));
          },
        );

        this.querySelector(".cart__quantity-minus").addEventListener(
          "click",
          () => {
            this.querySelector("input").stepDown();
            this.updateQuantity();
          },
        );
        this.querySelector(".cart__quantity-plus").addEventListener(
          "click",
          () => {
            this.querySelector("input").stepUp();
            this.updateQuantity();
          },
        );
      }

      timeout = null;

      updateQuantity() {
        if (this.timeout) {
          return;
        }

        this.timeout = setTimeout(() => {
          // this.querySelector('.cart_item_remove').classList.add('free-gift-loading')
          document.querySelector("cart-drawer").classList.add("is-loading");
          CartJS.updateItem(
            this.querySelector(".cart_item_remove").getAttribute("data-line"),
            this.querySelector("input").value,
          );
          this.timeout = null;
        }, 300);
      }
    },
  );
}

if (!customElements.get("quick-add")) {
  customElements.define(
    "quick-add",
    class QuickAdd extends HTMLElement {
      constructor() {
        super();
        this.querySelector("button[data-add-to-cart]").addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            event.stopPropagation();

            const variantId = this.querySelector('input[name="id"]').value;
            const props = {};

            const upsellProductId = Number(
              this.querySelector("button[data-add-to-cart]").getAttribute(
                "data-upsell-id",
              ),
            );

            this.querySelectorAll("input").forEach((item) => {
              if (item.getAttribute("name") === "id") {
                return;
              }

              props[item.getAttribute("name")] = props.value;
            });

            const upsellBlock = Array.from(
              document.querySelectorAll(".upsell-block"),
            ).find((item) => {
              return (
                Number(item.getAttribute("data-hasUpgradeProduct")) ===
                  upsellProductId &&
                Number(item.getAttribute("data-hasUpgradeProduct"))
              );
            });

            console.log(upsellBlock);

            if (upsellBlock) {
              upgradeFromVariantId = variantId;
              window.displayUpgrade = true;
              upgradeBlock = event.target.closest(".grid-item");
            }
            this.querySelector("button").classList.add("is-loading");
            $(document).on("cart.requestComplete", this.updateBtn.bind(this));
            CartJS.addItem(variantId, 1, props);
          },
        );
      }

      updateBtn() {
        this.querySelector("button").classList.add("is-added");
        this.querySelector("button").addEventListener(
          "transitionend",
          this.resetButton.bind(this),
        );

        if (window.displayUpgrade) {
          upgradeBlock.classList.add("activeupsell");
          window.addEventListener("transitionend", bodyOverflow);
          window.scrollTo(0, 0);
          window.displayUpgrade = false;
        }

        $(document).off("cart.requestComplete", this.updateBtn.bind(this));
      }

      resetButton() {
        this.querySelector("button").classList.remove("is-loading");
        this.querySelector("button").classList.remove("is-added");
        this.querySelector("button").removeEventListener(
          "transitionend",
          this.resetButton,
        );
      }
    },
  );
}

if (!customElements.get("cart-header")) {
  customElements.define(
    "cart-header",
    class CartHeader extends HTMLElement {
      constructor() {
        super();

        this.querySelector(".drawer__close").addEventListener(
          "click",
          (event) => {
            toggleCart();
          },
        );
      }
    },
  );
}

if (!customElements.get("cart-counter")) {
  customElements.define(
    "cart-counter",
    class CartHeader extends HTMLElement {
      constructor() {
        super();

        if (document.querySelector("#cart-json")) {
          this.cartJson = JSON.parse(
            document.querySelector("#cart-json").innerHTML,
          );

          let currentCount = Number(this.querySelector("span").innerHTML);

          const protectionId = Number(
            this.getAttribute("data-order-protection-id"),
          );

          for (const item of this.cartJson.items) {
            if (item.product_id === protectionId) {
              currentCount--;
            }
          }

          this.updateCount(currentCount);
        }
      }

      cartJson = null;

      updateCount(count) {
        if (!this.querySelector("span")) {
          this.appendChild(document.createElement("span"));
        }

        if (count === 0) {
          this.style.display = "none";
          return;
        }

        if (this.querySelector("span")) {
          this.querySelector("span").innerHTML = count;
          this.style.display = "flex";
        }
      }
    },
  );
}

if (!customElements.get("checkout-btn")) {
  customElements.define(
    "checkout-btn",
    class CheckoutBtn extends HTMLElement {
      constructor() {
        super();

        this.addEventListener("click", (event) => {
          if (this.classList.contains("free-gift-loading")) {
            return;
          }

          let popConfirm = false;
          document.querySelectorAll("free-gift-product").forEach((item) => {
            const btn = item.querySelector("#free-product-btn");
            if (
              getComputedStyle(item).display === "block" &&
              !btn.classList.contains("disabled")
            ) {
              popConfirm = true;
            }
          });

          if (popConfirm) {
            document.querySelector("checkout-confirm").style.display = "block";
          } else {
            this.classList.add("free-gift-loading");
            location.href = "/checkout";
          }
        });
      }
    },
  );
}
